

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sendFeedback} from "@/api";

@Component
export default class FeedbackButton extends Vue {

    private dialog: boolean = false;

    private feedback: string = ""

    private loading: boolean = false;

    /** `POST /api/feedback` answers 400 for a blank text and for one longer than this. */
    private readonly maxLength: number = 5000;

    get canSend(): boolean {
        return this.feedback.trim().length > 0 && this.feedback.length <= this.maxLength;
    }

    async sendFeedback() {
        if (this.loading || !this.canSend) {
            return;
        }

        this.loading = true;

        try {
            await sendFeedback(this.feedback);
        } catch (e) {
            // already shown by the http interceptor; keep the dialog and the text so that the user can try again
            return;
        } finally {
            this.loading = false;
        }

        this.dialog = false;
        this.feedback = "";

        this.$store.commit("setSnackbar", this.$t('feedback.send.succesful'));
    }
}
